module.exports = __webpack_public_path__ + "static/img/20201019110452366.fea0fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20201019110452366.png
// module id = oK+M
// module chunks = 73